import { useEffect } from "react";
import CategoryDetailTemplate from "../../../Templetes/Categories/Details/CategoryDetail.template";

const VirtualRobotPage = () => {
  useEffect(() => {
    document.title = "We Do Challenge - Virtual Robot Challenge";
  }, []);
  return <CategoryDetailTemplate />;
};

export default VirtualRobotPage;
